import React from "react";
import { useLocalization } from "@i18n";
import { formatGeneralDisplayValue } from "../utils/formatGeneralDisplayValue";
import type { FieldItem } from "./GeneralDashboardFieldGrid";

interface GeneralDashboardFieldStackProps {
  fields: FieldItem[];
  spread?: boolean;
}

export const GeneralDashboardFieldStack: React.FC<GeneralDashboardFieldStackProps> = ({
  fields,
  spread = false,
}) => {
  const { translate } = useLocalization();

  return (
    <div
      className={[
        "general-dashboard-field-stack flex w-full flex-col gap-2 text-foreground",
        spread ? "h-full flex-1 justify-between" : "",
      ].join(" ")}
    >
      {fields.map((field, index) => (
        <div key={`${field.labelKey}-${index}`} className="flex flex-col">
          <span className="text-xs font-bold leading-normal">
            {translate(field.labelKey)}
          </span>
          <span className="break-words text-sm font-normal leading-normal">
            {formatGeneralDisplayValue(field.value, field.isDate)}
          </span>
        </div>
      ))}
    </div>
  );
};
